import { Button } from '@cian/ui-kit';
import * as React from 'react';

interface IProps {
  onConfirm(): void;
  onCancel(): void;
}

export function ModalFooter({ onConfirm, onCancel }: IProps) {
  return (
    <>
      <Button size="XS" theme="fill_white_primary" onClick={onCancel}>
        Отменить
      </Button>
      <Button size="XS" onClick={onConfirm}>
        Удалить
      </Button>
    </>
  );
}
